import Vue from 'vue'
import VueRouter from 'vue-router'
// 配置router路由
import Import from '../../pages/Import.vue'
import WebHome from '../../pages/web/WebHome.vue'
import WebNoResult from '../../pages/web/WebNoResult.vue'
import Collate from '../../pages/Collate.vue'
import Record from '../../pages/Record.vue'
import Detail from '../../pages/Detail.vue'
import Share from '../../pages/Share.vue'
import Search from '../../pages/Search.vue'
import Comment from '../../pages/comment/Comment.vue'
import OtherComment from '../../pages/comment/OtherComment.vue'
import DiscussList from '../../pages/discuss/DiscussList.vue'
import Discuss from '../../pages/discuss/Discuss.vue'
import ChooseGroup from '../../pages/subpages/ChooseGroup.vue'
import GroupManage from '../../pages/subpages/GroupManage.vue'
import AllRecord from '../../pages/subpages/AllRecord.vue'
import EditDetail from '../../pages/subpages/EditDetail.vue'
import AdvancedSearch from '../../pages/subpages/AdvancedSearch.vue'
import SearchResult from '../../pages/subpages/SearchResult.vue'
import AdvancedCollate from '../../pages/subpages/AdvancedCollate.vue'
import Label from '../../pages/subpages/Label.vue'
import LabelManage from '../../pages/subpages/LabelManage.vue'
import Embedded from '../../pages/embedded/Embedded.vue'
import Donate from '../../pages/donate/Donate.vue'
import DonateForm from '../../pages/donate/DonateForm.vue'
import Report from '../../pages/report/Report.vue'
import ChooseRecord from '../../pages/subpages/ChooseRecord.vue'
import FamousPedia from '../../pages/famouspedia/FamousPedia.vue'
import FamousPediaTwo from '../../pages/famouspedia/FamousPediaTwo.vue'
import FamousPediaCreate from '../../pages/famouspedia/FamousPediaCreate.vue'
import FamousPediaInform from '../../pages/inform/FamousPediaInform.vue'
import FamousPediaEditHistory from '../../pages/famouspedia/FamousPediaEditHistory.vue'
import FamousPediaReadWeb from '../../pages/famouspedia/FamousPediaReadWeb.vue'
import FamousPediaEditWeb from '../../pages/famouspedia/FamousPediaEditWeb.vue'
import My from '../../pages/my/My.vue'

import { SHARE } from '../share'
import store from '../store'
import { RECORD_DOM } from '../dom'
import { CONFIG } from '../config'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
}
Vue.use(VueRouter);

/**
 * 定义路由
 */
export default new VueRouter({
    base: CONFIG.platform != 'wechat' ? '/'+CONFIG.platform+'/' : '/',
    mode: 'history',
    routes: [
        // {
        //     path: '/',
        //     redirect: '/home',
        //     beforeEnter: (to, from, next) => {
        //         next();
        //         setTimeout(() => {
        //             SHARE.initConfigShare();
        //         }, 100);
        //     }
        // },
        {
            path: '/import',
            component: Import,
            meta: {
                // 路由层级，数值越大层级越深，以此决定转场动画的前进和后退 大于前进，小于后退
                index: 0,
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/webhome',
            component: WebHome,
            meta: {
                index: 0,
                hideBodyBg: true
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/webnoresult',
            component: WebNoResult,
            meta: {
                index: 0,
                hideTopBar: true,
            }
        },
        {
            path: '/collate',
            component: Collate,
            meta: {
                index: 0,
            },
            children: [
                {
                    path: 'choosegroup',
                    component: ChooseGroup
                },
                {
                    path: 'advancedcollate',
                    component: AdvancedCollate
                },
                {
                    path: 'label',
                    component: Label
                },
                {
                    path: 'labelmanage',
                    component: LabelManage
                }
            ],
            beforeEnter: (to, from, next) => {
                var fromPath = from.path;
                if(fromPath.indexOf('detail/collate_advancedcollate') == -1) {
                    // 重置表单数据
                    store.dispatch('collate/resetData');
                    store.dispatch('group/resetChooseGroupData');
                    // 重置标签页数据
                    store.dispatch('label/resetData');
                }
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/record',
            component: Record,
            meta: {
                index: 0,
            },
            children: [
                {
                    path: 'groupmanage',
                    component: GroupManage
                },
                {
                    path: 'all',
                    component: AllRecord
                }
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
                setTimeout(() => {
                    RECORD_DOM.resetRecordListContentStyle();
                }, 200);
            }
        },
        {
            path: '/detail/:from/:id',
            component: Detail,
            meta: {
                index: 0,
            },
            children: [
                {
                    path: 'label',
                    component: Label
                },
                {
                    path: 'labelmanage',
                    component: LabelManage
                }
            ]
        },
        {
            path: '/edit/:from/:id',
            component: EditDetail,
            meta: {
                index: 0,
            },
            children: [
                {
                    path: 'choosegroup',
                    component: ChooseGroup
                },
                {
                    path: 'label',
                    component: Label
                }
            ]
        },
        {
            path: '/search',
            component: Search,
            meta: {
                index: 0,
            },
            children: [
                {
                    path: 'advanced',
                    component: AdvancedSearch
                },
                {
                    path: 'result',
                    component: SearchResult
                },
                {
                    path: 'label',
                    component: Label
                }
            ]
        },
        {
            path: '/comment/:from/:id',
            component: Comment,
            meta: {
                index: 0,
            }
        },
        {
            path: '/othercomment',
            component: OtherComment,
            meta: {
                index: 0,
            }
        },
        {
            path: '/discusslist/:id',
            component: DiscussList,
            meta: {
                index: 0,
            }
        },
        {
            path: '/discuss/:from/:id',
            component: Discuss,
            meta: {
                index: 0,
            }
        },
        {
            path: '/report/:from/:id',
            component: Report,
            meta: {
                index: 0,
            }
        },
        {
            path: '/share',
            component: Share,
            meta: {
                index: 0,
            },
            children: [
                {
                    path: 'detail/:id',
                    component: Detail,
                    children: [
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        },
                        {
                            path: 'label',
                            component: Label
                        }
                    ]
                },
                {
                    path: 'comment/:id',
                    component: Comment,
                    children: [
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        }
                    ]
                },
                {
                    path: 'discuss/:id',
                    component: Discuss,
                    children: [
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        }
                    ]
                },
            ]
        },
        {
            path: '/embedded',
            component: Embedded,
            meta: {
                index: 0,
            },
            children: [
                {
                    path: 'comment',
                    component: Comment,
                    children: [
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        }
                    ]
                },
                {
                    path: 'othercomment',
                    component: OtherComment
                },
                {
                    path: 'discusslist',
                    component: DiscussList
                },
                {
                    path: 'discuss',
                    component: Discuss,
                    children: [
                        {
                            path: 'choosegroup',
                            component: ChooseGroup
                        }
                    ]
                },
                {
                    path: 'report',
                    component: Report
                },
                {
                    path: 'label',
                    component: Label
                },
                {
                    path: 'labelmanage',
                    component: LabelManage
                }
            ]
        },
        {
            path: '/donate',
            component: Donate,
            meta: {
                index: 0,
            },
            children: [
                {
                    path: 'form',
                    component: DonateForm,
                    beforeEnter: (to, from, next) => {
                        next();
                        setTimeout(() => {
                            SHARE.initConfigShare();
                        }, 100);
                    }
                }
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/famouspedia',
            component: FamousPedia,
            meta: {
                index: 0,
            },
            children: [
                {
                    path: 'inform',
                    component: FamousPediaInform
                }
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/famouspediatwo',
            component: FamousPediaTwo,
            meta: {
                index: 0,
                hideTopBar: true
            }
        },
        {
            path: '/famouspediacreate',
            component: FamousPediaCreate,
            meta: {
                index: 1,
            },
            children: [
                {
                    path: 'choosegroup',
                    component: ChooseGroup
                },
                {
                    path: 'label',
                    component: Label
                },
                {
                    path: 'chooserecord',
                    component: ChooseRecord,
                    children: [
                        {
                            path: 'all',
                            component: AllRecord
                        }
                    ]
                }
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/famouspediareadweb/:id/:frompage',
            component: FamousPediaReadWeb,
            meta: {
                index: 1,
                hideTopBar: true,
            },
            children: [
                {
                    path: 'edithistory',
                    component: FamousPediaEditHistory
                },
                {
                    path: 'choosegroup',
                    component: ChooseGroup
                }
            ],
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/famouspediaeditweb/:frompage',
            component: FamousPediaEditWeb,
            meta: {
                index: 1,
                hideTopBar: true,
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            }
        },
        {
            path: '/my',
            component: My,
            meta: {
                index: 0,
            },
            beforeEnter: (to, from, next) => {
                next();
                setTimeout(() => {
                    store.state.public.curPath = to.path;
                    SHARE.initConfigShare();
                }, 100);
            }
        }
    ]
});